
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Auf dem Bauch, in der Embryohaltung oder auf dem Rücken? Die meisten von uns haben ihre persönliche Lieblingsposition. Doch insbesondere Menschen, die mit Rückenschmerzen oder Verspannungen zu kämpfen haben, sollten sich überlegen, ob die bequemste auch die gesündeste Art zu liegen ist. `}<M mdxType="M">{`Studien sind sich einig, die Bauchlage ist nicht zu empfehlen, das ist Gift für Nackenmuskulatur und Halswirbel.`}</M>{` So wird der Bauch in die Matratze gedrückt und der Kopf verdreht. Durch die Verdrehung der Halswirbelsäule – meist auch noch immer auf die gleiche Seite – kommt es zu einer Fehlhaltung. `}<br /><br />{`
Ärzte empfehlen eine Seiten- oder Rückenlage. Wer den ganzen Tag sitzt, sollte bei der Seitenlage aber auf stark angewinkelte Beine verzichten. Sonst bleibt die Hüftbeuger-Muskulatur – genau wie auf dem Bürostuhl – auch nachts gebeugt, was zu einer Verkürzung des Muskels führen kann. `}<M mdxType="M">{`Für viele Mediziner gilt deshalb das Schlafen auf dem Rücken als die gesündeste Variante – sofern man ein flaches Kissen verwendet und die Wirbelsäule gerade liegt.`}</M>{` Sie wird jedoch nur von rund sieben Prozent aller Menschen eingenommen. Für den Rückenschläfer ist eine Matratze mittlerer Härte am geeignetsten, da zu harte oder zu weiche Matratzen die Wirbelsäule nicht in eine gerade Lage bewegen können. `}<br /><br />{`
Allerdings hat die Rückenposition nicht nur Vorteile, sondern kann bei einigen Menschen auch das Schnarchen verstärken. Die Schlafposition ist übrigens eine reine Gewohnheitssache. Jeder, der will und übt, kann sich umgewöhnen. Ausserdem können Sie die Schlafposition während der Nacht auch wechseln. Das entspannt den Körper und aktiviert die Muskulatur.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;